import { render } from "./LinkNews.vue?vue&type=template&id=51091c0b&scoped=true"
import script from "./LinkNews.vue?vue&type=script&lang=js"
export * from "./LinkNews.vue?vue&type=script&lang=js"

import "./LinkNews.vue?vue&type=style&index=0&id=51091c0b&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51091c0b"]])

export default __exports__